export const sizesEn = [
  {
    name: '1:1',
    width: 512,
    height: 512,
  },
  {
    name: '1:1',
    width: 2048,
    height: 2048,
  },
  {
    name: '1:1',
    width: 1000,
    height: 1000,
  },
  {
    name: '1:1',
    width: 1024,
    height: 1024,
  },
  {
    name: '1:1',
    width: 1600,
    height: 1600,
  },
  {
    name: '1:1',
    width: 2000,
    height: 2000,
  },
  {
    name: '1:1',
    width: 500,
    height: 500,
  },
  // {
  //   name: 'Instagram post - 1:1',
  //   width: 1000,
  //   height: 1000,
  // },
  {
    name: '4:5',
    width: 1080,
    height: 1350,
  },
  {
    name: '9:16',
    width: 1080,
    height: 1920,
  },
];
